import { createApp } from 'vue'
import gtag from "vue-gtag-next"
import Toast from "vue-toastification"
import App from './App.vue'
import './index.css'
import "vue-toastification/dist/index.css"

const app = createApp(App)

app.use(gtag, {
  property: {
    id: "G-5CG5Y4FFCT"
  }
})

app.use(Toast, {
  
});

app.mount('#app')